<template lang="pug">

    form.ui.form(v-on:submit.prevent='submit()')

        //- Zusätzliche Angaben
        step-indicator(v-bind:activeStep='3')


        .field
            general-information-form(
                ref="generalInformation"
                v-bind:company='companyModel'
                v-model='model'
            )

        .field
            h3.ui.block.header Zusätzliche Angaben
            additional-information-form(
                ref="additionalInformation"
                v-bind:country-models='countries'
                v-bind:internal-shipping-address-models='[]'
                v-bind:media-production-person-models='mediaProductionPersons'
                v-bind:media-production-user-models='mediaProductionUsers'
                v-bind:purchaser-models='purchaserModels'
                v-model='model'
            )

        wizard-navigation(v-on:back="back()")

</template>

<script>
    import Vue from 'vue'
    import * as R from 'ramda'
    import store from '@/store'
    import Modal from '@/components/app/Modal'
    import AdditionalInformationForm from '@/components/products/forms/AdditionalInformationForm'
    import GeneralInformationForm from '@/components/products/forms/GeneralInformationForm'
    import StepIndicator from '@/components/products/StepIndicator'
    import WizardNavigation from '@/components/products/WizardNavigation'

    //noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols
    export default {
        name: 'products-create-step3-view',

        async beforeRouteEnter(to, from, next) {
            if (store.getters['products/draft'].type === undefined) {
                next({ name: 'products/create' })
            }

            // Unternehmens-ID des eingeloggten Benutzers speichern
            const companyId = Vue.$auth.companyId

            // Unternehmen laden
            await Promise.all([

                // Unternehmen laden
                store.dispatch('companies/loadOne', { id: companyId }),

                // MP-User laden
                store.dispatch('users/loadAllByCompanyIdAndIsMediaProduction', { companyId }),

                // MP-Personen laden
                store.dispatch('persons/loadAllByCompanyIdAndIsMediaProduction', { companyId }),

                // Alle Länder laden
                store.dispatch('countries/loadAll'),

            ])

            next()
        },

        created() {
            this.$scrollTo('body')
        },

        components: {
            AdditionalInformationForm, GeneralInformationForm, Modal, StepIndicator, WizardNavigation
        },

        computed: {

            countries() {
                return store.getters['countries/all']
            },

            companyModel() {
                return store.getters['companies/byId'](Vue.$auth.companyId)
            },

            isInvalid() {
                return this.$refs.generalInformation.$v.$invalid ||
                    this.$refs.additionalInformation.$v.$invalid
            },

            mediaProductionUsers() {
                return store.getters['users/allByHasMediaProductionRole']
            },

            mediaProductionPersons() {
                return R.compose(

                    // Personen-Models aus Store laden
                    // > [ 1, 2 ]
                    // < [ { id: 1 }, { id: 2 } ]
                    R.map(store.getters['persons/byId']),

                    // Person-ID aus Benutzer-Models auslesen
                    // > [ { person: 1, ... }, { person: 2, ... } ]
                    // < [ 1, 2 ]
                    R.map(R.prop('person'))

                )(this.mediaProductionUsers)
            },

            model: {
                get() { return this.$store.getters['products/draft'] || {} },
                set(model) { this.$store.commit('products/REPLACE_DRAFT', { draft: model }) }
            },

            purchaserModels() {
                return [ this.companyModel ]
            },

        },

        methods: {

            back() {
                this.$router.push({
                    name: 'products/create/step2',
                    params: this.$route.params
                })
            },

            async submit() {
                // Embedded-Forms als "submitted" markieren
                this.$refs.generalInformation.$v.$touch()
                this.$refs.additionalInformation.$v.$touch()

                // Pruefen ob alle Formular valide sind
                if (this.isInvalid) {
                    this.$scrollToAndFocus('.field.error')
                    return
                }

                // Belegexemplare (inkl. Empfänger) validieren
                if (!await this.$refs.additionalInformation.validate()) {
                    this.$scrollToAndFocus('.field.error')
                    return
                }

                // Auf zu Step 4!
                this.$router.push({
                    name: 'products/create/step4',
                    params: this.$route.params
                })
            }

        },


        watch: {

            'model.company'(companyId) {
                // Lieferadressen des Unternehmens laden
                store.dispatch('addresses/loadAllByCompanyIdAndIsShippingAddress', { companyId })
            }

        }

    }

</script>

<!--suppress CssUnusedSymbol -->
<style>

    .v--modal-overlay {
        background: rgba(0, 0, 0, 0.85);
    }

</style>
